import { render } from "./multi-store-drawer-trigger.vue?vue&type=template&id=00b8100a"
import script from "./multi-store-drawer-trigger.vue?vue&type=script&lang=js"
export * from "./multi-store-drawer-trigger.vue?vue&type=script&lang=js"

import "./multi-store-drawer-trigger.vue?vue&type=style&index=0&id=00b8100a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__